import { connect } from 'react-redux';
import * as projectsSelectors from 'redux-modules/projects/selectors.js';
import * as projectsActions from 'redux-modules/projects/actions.js';
import * as authSelectors from 'redux-modules/auth/selectors.js';
import ProjectsPage from './ProjectsPage';

function mapStateToProps(state) {
  return {
    authToken: authSelectors.selectAuthToken(state),
    projectData: projectsSelectors.selectMyProjects(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: () => {
      var action = projectsActions.loadProjects();
      dispatch(action);
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectsPage);
